import { push } from 'react-router-redux';

const errorRegex = /\berror=[^&]+&?/g;

export function cleanSearchString(search) {
    let cleanedSearch = search.replace(errorRegex, '');

    if (cleanedSearch.charAt(cleanedSearch.length - 1) === '&') {
        cleanedSearch = cleanedSearch.slice(0, -1);
    }

    if (cleanedSearch.charAt(cleanedSearch.length - 1) === '?') {
        cleanedSearch = cleanedSearch.slice(0, -1);
    }

    return cleanedSearch;
}

export const pushWithQuery = propsOrPath => {
    const windowSearch = window.location.search;

    if (propsOrPath.length > 0) {
        return push({
            pathname: propsOrPath,
            search: windowSearch
                ? cleanSearchString(windowSearch)
                : windowSearch,
        });
    } else {
        return push({
            ...propsOrPath,
            search: windowSearch
                ? cleanSearchString(windowSearch)
                : windowSearch,
        });
    }
};
